import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth14: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.9,81.1l-6.1,24.3-13.5,44.9c-41.3,30.7-81.6-11.9-81.6-11.9l-1.3-5.2-2.7-10.6-3.2-11.1-5-21-.9-9.7v-15.6s2.2-6.5,2.2-6.5l4-7,3.8-3.1,2.5-.7,11.7-13.1,9-7.6,8.4-5,7.6-2,13.5.2,6.7,1.6,16.2,7,15.8,9.9,7,4.9,4.3,6.5,3.4,12.6v11.1s-1.6,7.2-1.6,7.2h-.2Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41,138.6l-4-16.2h4.1c15.6,0,16.2-9.8,16.2-9.8l1.4-51.5h48.9s-.6,52.6-.6,52.6c-.2,10.1,12,11,12,11h11.2s-7.7,25.8-7.7,25.8c-52.9,29.6-81.6-11.9-81.6-11.9h0Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '29.5 60.1 29.5 57.7 32 53.8 35.9 49.8 40.5 47.8 60.4 27.4 67.6 23.2 76.5 20.5 90.6 20.5 104.6 24.7 118.4 31.8 130 39.6 137.7 45.9 141.5 53.6 143 61 107.6 61 58.7 61 29.5 60.9 29.5 60.1',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.9,113.6c0,14.9,23.2,11,23.2,11l13.4-48.9v-11.6s-2.3-12.9-2.3-12.9l-4.8-7.3-9.3-6.3-19.5-11.6v35s-.6,52.6-.6,52.6h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.7,60.7l.9-32.6-4.8,3.8-7.3,7.2-6.1,7.2-2.9,1.1-3.6,2-3.4,4.5-2.7,5.4-.9,7.2-.5,10.9.5,7.2,4.5,19.5,4.6,18.2c18.8,2.1,20.3-9.8,20.3-9.8l1.4-51.5v-.3Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.9,81.1l-6.1,24.3-13.5,44.9c-41.3,30.7-81.6-11.9-81.6-11.9l-1.3-5.2-2.7-10.6-3.2-11.1-5-21-.9-9.7v-15.6s2.2-6.5,2.2-6.5l4-7,3.8-3.1,2.5-.7,11.7-13.1,9-7.6,8.4-5,7.6-2,13.5.2,6.7,1.6,16.2,7,15.8,9.9,7,4.9,4.3,6.5,3.4,12.6v11.1s-1.6,7.2-1.6,7.2h-.2Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.9,138.5c33.8,39.3,81.6,11.9,81.6,11.9l-.5,10c-56.5,18.4-78.8-7.9-78.8-7.9l-2.3-13.9h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'29 86.7 41.4 105.2 44.8 79.3 56.1 110.1 64.5 79.3 74.9 111.7 84.4 81.3 94.8 111.7 104.1 81 114.1 111.7 121.9 81.8 127.7 106.4 139.3 88.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'47.6 395.7 60.5 382.4 52.1 370.7 65.7 363.3 58.3 351.5 72.3 343.8 59 333.5 74.9 328.7 61.6 317.6 76.7 311 63.1 301.4 78.2 295.9 66.4 283.4 80.4 280.5 68.8 268.8 84 263.1 72.6 253.9 85 250 74.3 242.6 84.5 235.4 73.8 228 86.6 218.9 75.5 211.3 86.6 203.3 75.3 195.5 87.7 186.7 75.8 178.3 89 168.6 77.4 160.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'48.3 265.6 54.8 279.7 61.3 265.2 68.9 281 76.7 265.2 83.2 281.8 90.3 268 96.2 279.7 101.3 266.9 106 281 110 267.6',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '126 60.7 129.5 68.1 134.3 78.4 136.3 87 135.7 99.2 135.3 107.9 133.5 118.9 129.3 129.4 123.6 139 115.2 147.7 107.2 155.3 100.9 159.3 92.1 162.7 86.3 163.3 82.2 163.5 76.2 163.1 72 162.3 63.8 160.1 53.3 152.5 46.9 147.7 41.3 140.4 34.4 126.4 30.8 114.7 30 106.1 29.8 95.8 30.2 89.4 32.8 77.1 34.6 71.7 39 63.3 42.7 57.9 51.1 50.2 56.9 46.4 66.4 42.6 73 41 79 39.8 91.3 40 97.7 41.2 104.5 43.2 111.6 47.2 118 52 124.6 59.3 126 60.7',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M131.4,124c-52.8-17.1-1-53.6-1-53.6l2.6,5.9,2.8,10.3.3,14.7-.8,6.9-3.9,15.7h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.2,72.5c51,38.3.2,55.5.2,55.5l-3.6-11.8-1.1-8.8.2-16.9,1.5-9,2.9-9h-.1Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.3,72.7l2.7-5.8,4.8-7.1,6.8-7.2,7.2-5.3,10.1-4.5,10.3-2.1,13.3-.3,7.8,1.1,7.8,2.3,8.2,4.6,8.5,7.9,8.7,14.2s-17.9,22-29.5,22-6-9-18.2-8.9-5.9,8.1-18.9,8.3c-13,.2-29.6-19.4-29.6-19.4v.2h0Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.6,128l4.7,9.5,7.1,9.3,8.8,8.2,9.6,6,9.6,3.1,16.3-.3,9-3.7,5.7-3.1,7.9-6.3,8.2-8.6,6.7-9.8,3.4-8.4s-18.9-13.7-30.6-13.8c-11.7,0-7.9,8.4-18.5,8.2s-5.3-7-18.1-7.2-29.9,16.9-29.9,16.9h.1Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.6,86.6c-11.3,16-2,25.8-2,25.8,0,0,1.5-2.4-10.8-2.4s-5.4,8.2-18.5,8.2-7.1-7.2-18.1-7.2-10.3,2.8-10.3,2.8c7.8-14.5-5-28-5-28,0,0,3.6,5.9,14.9,5.9s7.1-8.3,18.9-8.3,12.1,8.9,18.2,8.9,12.7-5.6,12.7-5.6h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M130.5,70.4c-47.3-34.3-96.2,2.1-96.2,2.1l2.7-5.8,4.8-7.1,6.8-7.2,7.2-5.3,10.1-4.5,10.3-2.1,13.3-.3,7.8,1.1,7.8,2.3,8.2,4.6,8.5,7.9,8.7,14.2h0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.5,128c55.7,43.1,97-4.1,97-4.1l-3.4,8.4-6.7,9.8-8.2,8.6-7.9,6.3-5.7,3.1-9,3.7-16.3.3-9.6-3.1-9.6-6-8.8-8.2-7.1-9.3-4.7-9.5h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'30.8 93.1 41.7 107.4 47.1 87.4 54.4 111.8 63.7 86.8 72.6 111.8 82.2 87.1 91.3 111.8 101 85.6 109.1 110.7 119.4 85.6 122.7 106.5 136.1 93.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.7,372.1c41-11,77.6-1.6,77.6-1.6l4.7,16.7,4.6,18,3.1,17.3.8,10-.7,8.7-2.8,12.7-7.8,14.1-11,11.8-14.2,7.7-11.9,2.8-14.9-.2-10.1-3.6-10.1-8.5-12.4-16.7-8.7-18.1-.8-6.5v-16.7s1.3-9.3,1.3-9.3c0,0,12.7-38.3,13.2-38.4v-.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.7,372.1c41-11,77.6-1.6,77.6-1.6l4.7,16.7,4.6,18,3.1,17.3.8,10-.7,8.7-2.8,12.7-7.8,14.1-11,11.8-14.2,7.7-11.9,2.8-14.9-.2-10.1-3.6-10.1-8.5-12.4-16.7-8.7-18.1-.8-6.5v-16.7s1.3-9.3,1.3-9.3c0,0,12.7-38.3,13.2-38.4v-.2Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.3,398.7c-12.7-.8-11.6,11.4-11.6,11.4l.2,26.3-36,.2-.2-27.1c-.2-12-10.4-11.4-10.4-11.4l-16.7.2,8.9-26.2c44.5-10.8,77.5-1.4,77.5-1.4l7.2,28h-18.9Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M104.9,485.4l-3.2,1.3v-50.1s-.2-26.3-.2-26.3c-.3-13,11.6-11.4,11.6-11.4h18.9s2,6.8,2,6.8l2.9,10.7,1.5,10.4-.2,11.4-1.6,10.5-3.6,9.4-5.4,9.4-8.2,9.3-14.3,8.5h-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.4,398.4l16.7-.2c10.8-.2,10.4,11.4,10.4,11.4l.2,27.1,1.2,49.5-1.9-.8-10.8-8.4-7.4-10.2-7.4-12.2-4.3-9.6-1.9-8.1.2-18.6,1.2-5.7,4-14.3h-.2Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '33.5 440.2 35.5 446.2 39.9 456.1 45.3 465.5 52.6 475.1 59.9 482.6 68.3 487.9 77.4 490.5 90.2 490.8 100.3 488.1 109.4 483.8 120.1 476.5 127.3 468.5 133.7 457.5 137.5 445 137.6 436.6 101.8 436.5 65.8 436.6 33.1 436.9 33.5 440.2',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.4,365.6c-31.7-13.2-75.7,1.1-75.7,1.1l-1,5.6c41.9-10.9,77.6-1.6,77.6-1.6l-.9-5.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'138.2 434.8 127 419.4 123.9 443.3 113.6 414.8 105.7 443.3 96.1 413.3 87.3 441.5 77.7 413.3 69.1 441.8 59.9 413.3 52.7 441 47.5 418.3 33.2 433.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'75.9 92.2 72.1 119.2 86.9 129.7 74.2 143 88.9 152.3 71.8 163.5 87.6 173.5 73 183.1 89.1 193.3 74.6 202.8 91 213.1 76.1 222.9 90.2 231.8 77.9 239.9 92.3 248.7 79 257.4 93.2 266.4 79.3 275.6 92.8 284.2 79.9 292.4 93.6 301 77.3 311.4 91.3 320.1 77.3 329.4 91.5 338.2 75.9 348.4 91 358.1 74.2 369.2 88.9 378.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'123.2 243.5 118.4 228.3 111.8 243.3 106.3 226.8 100 242.9 92.4 226.8 84.9 242.4 79.6 227.5 74.1 242.3 66.6 227 63.3 242.1',
			],
		},
	},
};
